<template>
  <div id="basketball_recordTeamData">
    <div class="select_row_box" v-if="crossSeason">
      <SelectItem
        v-for="selectItem in selectList"
        :key="selectItem.state"
        :options="selectItem"
        :curVal="selectItem.curVal"
        @changeValEvent="selectChangeVal"
      ></SelectItem>
    </div>
    <div class="select_area">
      <marathon_select_opt
        :currThemeObj="currThemeObj"
        :data="selectOptData"
        @changeSelectEvent="changeSelect"
      ></marathon_select_opt>
    </div>
    <div class="group_box">
      <div class="table_container" ref="tableParentDom">
        <template v-if="tableColumnData && tableColumnData.length > 0">
          <nodeTree_table
            :currThemeObj="currThemeObj"
            :currCid="currCid"
            :currSid="currSid"
            :tableMode="tableMode"
            :parentWidthPx="parentWidthPx"
            :isScrollFlag="isScrollFlag"
            :isClickFlag="isClickFlag"
            :variableColWidthVw="variableColWidthVw"
            :tableCellDefaultWidthVw="tableCellDefaultWidthVw"
            :defaultWidthVwNum="defaultWidthVwNum"
            :tableColumnData="tableColumnData"
            :tableData="tableData"
            :tableHeightPx="0"
            @clickColumnEvent="clickColumn"
            :initColumnIndex="initColumnIndex"
            valFormatReturnDefaultVal="- -"
            :jumpRouterPathNames="jumpRouterPathNames"
            :unClickDetailMode="unClickDetailMode"
            v-show="tableData && tableData.length > 0"
          ></nodeTree_table>
        </template>
        <!-- <div class="common_elPage">
          <el-pagination
            v-show="tableData && tableData.length > 0"
            popper-class="mixtmt_pagination"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pnum"
            :page-sizes="psizeArr"
            :page-size="psize"
            layout="total, prev, pager, next, sizes, jumper"
            :total="total"
          ></el-pagination>
        </div> -->
      </div>
      <cup_notData
        v-show="tableData && tableData.length === 0"
        className="relativePtb60"
      ></cup_notData>
    </div>
  </div>
</template>
<script>
import {
  https_basketball_seasonList,
  https_record_teamStatList,
} from '@api/platfrom_basketball_api'

import SelectItem from '@components/platfromBase/basketball/selectItem.vue'
import marathon_select_opt from '@components/platfromBase/marathon/select_opt.vue'
import nodeTree_table from '@components/platfromBase/marathon/nodeTree_table.vue'
import cup_base_data_mixin from '@mixins/cup_base_data'
import cup_notData from '@components/base/NO_DATA.vue'

export default {
  name: 'basketball_recordTeamData',
  components: { SelectItem, marathon_select_opt, nodeTree_table, cup_notData },
  mixins: [cup_base_data_mixin],
  props: {
    crossSeason: {
      type: Boolean,
      default: true, // 默认联赛
    },
    phaseArr: {
      type: Array,
      default: () => {
        // 默认返回联赛的
        return [
          {
            phaseId: '1',
            phaseName: '常规赛',
          },
          {
            phaseId: '2',
            phaseName: '季后赛',
          },
          {
            phaseId: '9',
            phaseName: '保级赛',
          },
        ]
      },
    },
    isBasketballCupFlag: {
      //判断是否篮球杯赛，篮球杯赛和篮球联赛cid不一样
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      curSelect_dataType: '1',
      selectList: [
        {
          list: [
            {
              id: '1',
              name: '基础数据',
            },
            // {
            //   id: '2',
            //   name: '高阶数据',
            // },
          ],
          keyValArr: ['id', 'name'],
          placeholder: '请选择',
          isFilterable: false,
          widthVw: 9.74,
          curVal: '',
          state: 'dataType',
        },
      ],
      loading: false,
      tableMode: 'teamData leagueCBA',
      jumpRouterPathNames: {
        pathName_teamDetail: 'teamDetailIndex',
        pathName_playerDetail: 'playerDetailIndex',
      },
      parentWidthPx: 0,
      parentHeightPx: 0,
      isScrollFlag: true,
      isClickFlag: true,
      variableColWidthVw: 6.94,
      tableCellDefaultWidthVw: 5.55,
      defaultWidthVwNum: null,
      tableColumnData: [],
      initColumnIndex: 0,
      sortKey: '',
      pnum: 1,
      psize: 10,
      psizeArr: [10, 20, 30, 50],
      total: 0,
      tableData: null,
      currStageSeason: '',
      currStagePhase: '1',
      currStageStatDimension: 'avg',
      ascFlag: false,
      selectAllObj: {
        value: 'all',
        name: '全部',
      },
      seasonArr: [],
      statDimensionArr: [
        {
          statDimensionId: 'sum',
          statDimensionName: '总和',
        },
        {
          statDimensionId: 'avg',
          statDimensionName: '场均数据',
        },
      ],
      selectOptData: {
        configArr: [
          {
            type: 'season',
            title: '赛季',
            origin_keyVal: ['seasonId', 'seasonName'],
            dataName: 'seasonArr',
            selectIndex: 0,
            isFilterable: true,
          },
          {
            type: 'phase',
            title: '赛段',
            origin_keyVal: ['phaseId', 'phaseName'],
            dataName: 'phaseArr',
            selectIndex: 0,
            isFilterable: true,
          },
          {
            type: 'statDimension',
            title: '统计维度',
            origin_keyVal: ['statDimensionId', 'statDimensionName'],
            dataName: 'statDimensionArr',
            selectIndex: 1,
            isFilterable: true,
          },
        ],
        selectOpt_list: [],
      },
    }
  },
  created() {
    if (this.currThemeObj) {
      const moduleRouteNameEn = this.currThemeObj.moduleRouteNameEn
      this.jumpRouterPathNames = {
        pathName_teamDetail: `teamDetailIndex_${moduleRouteNameEn}`,
        pathName_playerDetail: `playerDetailIndex_${moduleRouteNameEn}`,
      }
      if (!this.crossSeason) {
        this.currStageSeason = this.currSid
        const configArr = []
        this.selectOptData.configArr.forEach((item, index) => {
          if (index !== 0) {
            configArr.push(item)
          }
        })
        this.selectOptData.configArr = configArr
      }
    }
    this.init()
  },
  mounted() {
    this.parentWidthPx = this.$refs.tableParentDom.offsetWidth
    console.debug('this.parentWidthPx:', this.$refs.tableParentDom.scrollHeight)
  },
  computed: {
    unClickDetailMode() {
      console.debug('this.currThemeObj:', this.currThemeObj)
      let flag = false
      if (['FIBAWA', 'FIBAMA'].includes(this.currThemeObj.moduleRouteNameEn)) {
        flag = true //不可点击进入详情
      }
      return flag
    },
  },
  methods: {
    async init() {
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      if (this.crossSeason) {
        await this.asyncInitSelectOpt()
        await this.getSeasonList()
      }
      this.computedSelectOpt(this.selectOptData.configArr)
      await this.getRecordTeamData()
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    clickColumn(prop) {
      console.debug(prop)
      this.sortKey = prop
      this.getRecordTeamData()
    },
    computedSelectOpt(configArr) {
      // 组装选择框数据
      let selectOpt_list = []
      configArr.forEach((config, index) => {
        let disabledArr = []
        const mix_id = `mix_${config.origin_keyVal[0]}`
        let list = []
        if (config.isDatePicker) {
          // 日期选择框没有 dataName 属性
          selectOpt_list.push({
            type: config.type,
            title: config.title,
            keyVal: [mix_id, config.origin_keyVal[1]],
            curId: mix_id, //list[config.selectIndex][mix_id], // 选中的id,是改装后的，需要去掉前缀才是源数据的唯一id
            curVal: this.currStageMatchDate ? this.currStageMatchDate : '', // 这个值是源数据需要展示的值，没有做过修改
            disabledArr,
            list,
            isDatePicker: config.isDatePicker,
          })
        } else {
          list = this[config.dataName].map((item) => {
            item[mix_id] = `${config.type}_${item[config.origin_keyVal[0]]}`
            return item
          })
          console.debug(
            'computedSelectOpt:',
            config.dataName,
            this[config.dataName],
            list,
            mix_id
          )
          selectOpt_list.push({
            type: config.type,
            title: config.title,
            keyVal: [mix_id, config.origin_keyVal[1]],
            curId: list[config.selectIndex][mix_id], // 选中的id,是改装后的，需要去掉前缀才是源数据的唯一id
            curVal: list[config.selectIndex][config.origin_keyVal[1]], // 这个值是源数据需要展示的值，没有做过修改
            disabledArr, //当【阶段】选择为淘汰赛时，球队这栏置灰；所以在【球队】这组对象的disabledArr=['stage_2']；而【阶段】的disabledArr = []。在marathon_select_opt组件中也需要做一些逻辑处理，主要是对curStageVal这个值
            isFilterable: config.isFilterable ? config.isFilterable : false,
            list,
          })
        }
      })

      this.selectOptData.selectOpt_list = selectOpt_list
      console.debug('this.selectOptData.selectOpt_list', selectOpt_list)
    },
    changeSelect(data) {
      console.debug(data)
      let state = ''
      let valPathArr = []
      let val = data.val
      // 选择后，重置联动的筛选框
      // let updateSelectIndex = -1
      if (data.type === 'select') {
        if (val.indexOf('_') > -1) {
          valPathArr = val.split('_')
          for (let i = 0; i < this.selectOptData.selectOpt_list.length; i++) {
            let item = this.selectOptData.selectOpt_list[i]
            const idKey = item.keyVal[0]
            const valKey = item.keyVal[1]
            if (item.type == valPathArr[0]) {
              for (let j = 0; j < item.list.length; j++) {
                let cell = item.list[j]
                console.debug(idKey, val)
                if (cell[idKey] == val) {
                  console.debug(cell[idKey], val)
                  // updateSelectIndex = i
                  item.curVal = cell[valKey]
                  break
                }
              }
            }
          }
          if (valPathArr[0] === 'season') {
            this.currStageSeason = valPathArr[1]
            // this.computedSelectOpt(this.selectOptData.configArr)
          } else if (valPathArr[0] === 'phase') {
            this.currStagePhase = valPathArr[1]
            state = ''
            // this.computedSelectOpt(this.selectOptData.configArr)
          } else if (valPathArr[0] === 'statDimension') {
            this.currStageStatDimension = valPathArr[1]
            // this.computedSelectOpt(this.selectOptData.configArr)
          } else {
          }
          // 筛选表格逻辑
          this.resetTable(state)
        } else {
          console.debug('id命名方式不符合组件规则')
        }
      } else {
        console.debug('data.type 没有匹配成功')
      }
    },
    async asyncInitSelectOpt() {
      setTimeout(() => {
        this.initSelectOpt()
      }, 100)
    },
    initSelectOpt() {
      let selectList = this.selectList
      this.selectList = selectList.map((item) => {
        if (item) {
          item.curVal = this[`curSelect_${item.state}`]
        }
        return item
      })
    },
    selectChangeVal(data) {
      console.debug('selectChangeVal:', data)
      if (data.state === 'dataType') {
        this.curSelect_dataType = data.val
      }
      console.debug(this.curSelect_dataType)
    },
    resetTable(state) {
      this.initTableParams(state)
      this.getRecordTeamData()
    },
    initTableParams(state) {
      this.pnum = 1
      if (state === 'resetColumnData') {
        this.sortKey = ''
        this.tableColumnData = []
      }
    },
    handleSizeChange(val) {
      this.psize = val
      this.resetTable()
      console.debug(`每页 ${val} 条`)
    },
    handleCurrentChange(val) {
      console.debug(`当前页: ${val}`)
      this.pnum = val
      this.getRecordTeamData()
    },
    async getSeasonList() {
      await https_basketball_seasonList(this.axiosBaseUrl, this.$axios, {
        cid: this.currCid,
      })
        .then((response) => {
          const res = response.data
          console.debug('res:', res)
          if (res.status === 0) {
            this.seasonArr = res.data
            this.currStageSeason = this.seasonArr[0].seasonId
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.matchPanel_matchInfor = null
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async getRecordTeamData() {
      await https_record_teamStatList(this.axiosBaseUrl, this.$axios, {
        sid: this.isBasketballCupFlag ? this.currSid : this.currStageSeason,
        phid: this.currStagePhase,
        stat: this.currStageStatDimension,
        sort: this.sortKey,
        asc: this.ascFlag,
      })
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            if (res.data && res.data.middle) {
              const leftColumns = res.data.left
              const middleColumns = res.data.middle
              const rightColumns = res.data.right
              this.defaultWidthVwNum =
                res.data.middle.length + res.data.left.length - 1 //减去【球队】特殊宽度的一列
              if (this.tableColumnData.length == 0) {
                let tableColumnData = []
                let leftColumnObjArr = []
                let rightColumnObjArr = []
                for (let i = 0; i < leftColumns.length; i++) {
                  const item = leftColumns[i]
                  let widthVw = this.tableCellDefaultWidthVw
                  if (item.colKey === 'teamName') {
                    widthVw = this.variableColWidthVw
                  }
                  leftColumnObjArr.push({
                    prop: item.colKey, //fristColumnPropArr.join('-'),
                    label: item.colTitle,
                    widthVw, //对应列的宽度，单位vw
                    className: '', //单独定制的头部样式class
                    fixed: 'left', //是否锁定，如果开启不滚动，此字段无效
                    selected: this.isClickFlag ? item.selected : false,
                  })
                }

                tableColumnData = [].concat(leftColumnObjArr)
                for (let i = 0; i < middleColumns.length; i++) {
                  const item = middleColumns[i]
                  tableColumnData.push({
                    prop: item.colKey,
                    label: item.colTitle,
                    widthVw: this.tableCellDefaultWidthVw, //对应列的宽度，单位vw
                    className: '', //单独定制的头部样式class
                    selected: this.isClickFlag ? item.selected : false,
                  })
                }

                for (let i = 0; i < rightColumns.length; i++) {
                  rightColumnObjArr.push({
                    prop: 'leftTeamName', //fristColumnPropArr.join('-'),
                    label: '球队',
                    widthVw: this.variableColWidthVw, //对应列的宽度，单位vw
                    className: 'columnTeamNameClass', //单独定制的头部样式class
                    fixed: 'right', //是否锁定，如果开启不滚动，此字段无效
                    selected: this.isClickFlag ? item.selected : false,
                  })
                }

                this.tableColumnData = [].concat(
                  tableColumnData,
                  rightColumnObjArr
                )
                this.tableColumnData.forEach((colItem, colIndex) => {
                  if (colItem.selected) {
                    this.initColumnIndex = colIndex
                  }
                })
              }
              this.tableData = res.data ? res.data.datas : []
              console.debug('this.tableData:', this.tableData)
            } else {
              console.debug('暂无数据')
            }
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
  },
}
</script>
<style lang="scss" scoped>
#basketball_recordTeamData {
  .select_row_box {
    padding-top: 1.388vw;
    width: 100%;
    display: flex;
    display: -webkit-flex;
    justify-content: flex-start;
    align-items: center;
    & > div {
      margin-right: 0.694vw;
    }
  }
  .select_area {
    padding: 1.388vw 0;
  }
  .group_box {
    padding-bottom: 2.778vw;
  }
}
</style>
